import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import { CheckIn } from "app/common/Model/CheckIn";
import { TYPE_CARD } from "app/common/LocalConst";
import { RegisterCard } from "app/common/Model/RegisterCard";
import {
  getRewardPointById,
  pagingRewardPoint,
  deleteRewardPoint,
  saveOrUpdateRewardPoint,
} from "app/services/RewardPoint";
import { getCurrentStaff } from "app/common/LocalFunction";
import {
  getFileById,
  uploadFile,
} from "app/services/FileDescriptionExtService";

const DEFAULT_INITIAL = {
  staff: getCurrentStaff(),
  pointAccumulationTime: new Date(),
};
export default class RewardPointListStore {
  searchRewardPoint = {
    ...new SearchObject(),
    // fromDate: new Date(),
    // toDate: new Date(),
  };

  pageRewardPoint = new PageResponse();
  openCreateOrEditRewardPointPopup = false;
  initRewardPoint = { ...DEFAULT_INITIAL };
  openConfirmDelete = null;
  openConfirmMessage = null;
  selectedFile = null;
  constructor() {
    makeAutoObservable(this);
  }

  pagingRewardPoint = async () => {
    let { pointRankId, staffId, patientId, ...ortherData } =
      this.searchRewardPoint;
    if (pointRankId) {
      ortherData.pointRankId = pointRankId?.id;
    }
    if (staffId) {
      ortherData.staffId = staffId?.id;
    }
    if (patientId) {
      ortherData.patientId = patientId?.id;
    }

    return await pagingRewardPoint({ ...ortherData })
      .then(({ data }) => {
        this.pageRewardPoint = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu tích điểm có lỗi");
      });
  };

  saveOrUpdateRewardPoint = async (values) => {
    const fileDescription = {
      id: this.selectedFile?.id,
    };
    return await saveOrUpdateRewardPoint({ ...values, fileDescription })
      .then(({ data }) => {
        this.openCreateOrEditRewardPointPopup = false;
        toast.success("Lưu tích điểm thành công");
        this.pagingRewardPoint();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin đăng ký tích điểm có lỗi");
      });
  };

  setSelectedFile = (img) => {
    this.selectedFile = img;
  };

  handleChangeFormSearchRewardPoint = (searchRewardPoint) => {
    this.searchRewardPoint = {
      ...this.searchRewardPoint,
      ...searchRewardPoint,
    };
    this.pagingRewardPoint();
  };

  handleOpenCreateOrEditRewardPointPopup = async (rewardPoint) => {
    if (Boolean(rewardPoint)) {
      getRewardPointById(rewardPoint?.id).then(async ({ data }) => {
        if (data?.fileDescription && data?.fileDescription?.id) {
          let dataId = await this.handleGetFileDescription(
            data?.fileDescription?.id
          );
          if (dataId instanceof Blob) {
            const fileInfoResponses = {
              src: URL.createObjectURL(dataId),
              name: data?.fileDescription?.name,
              id: data?.fileDescription?.id,
            };
            this.selectedFile = fileInfoResponses;
          }
        }
        this.initRewardPoint = data;
        this.openCreateOrEditRewardPointPopup = true;
      });
    } else {
      this.openCreateOrEditRewardPointPopup = true;
    }
  };

  handleCloseCreateOrEditRewardPointPopup = () => {
    this.openCreateOrEditRewardPointPopup = false;
    this.initRewardPoint = { ...DEFAULT_INITIAL };
    this.selectedFile = null;
  };

  handleOpenConfirmDelete = (id) => {
    this.openConfirmDelete = id;
  };

  handleDeleteRewardPoint = async () => {
    return await deleteRewardPoint(this.openConfirmDelete)
      .then(({ data }) => {
        this.openConfirmDelete = null;
        if (data?.responseStatus === false) {
          toast.error(data?.responseDetail);
        } else {
          toast.success("Xóa tích điểm thành công");
          this.pagingRewardPoint();
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Xóa tích điểm có lỗi");
      });
  };

  handleCloseConfirmMessage = () => {
    this.openConfirmMessage = null;
  };

  handleCloseConfirmDialog = () => {
    this.openConfirmDelete = false;
  };

  handleUpload = async (file) => {
    try {
      const { data } = await uploadFile(file);
      let fileInfoResponses;
      if (data) {
        let dataId = await this.handleGetFileDescription(data?.id);
        if (dataId instanceof Blob) {
          fileInfoResponses = {
            src: URL.createObjectURL(dataId),
            name: data?.name,
            id: data?.id,
          };
        }
      }

      return fileInfoResponses;
    } catch (err) {
      console.error("Lỗi trong quá trình upload ảnh:", err);
    }
  };

  handleGetFileDescription = async (id) => {
    try {
      const { data } = await getFileById(id);
      return data;
    } catch (error) {
      toast.error(error);
    }
  };

  resetStore = () => {
    this.searchRewardPoint = {
      ...new SearchObject(),
      // fromDate: new Date(),
      // toDate: new Date(),
    };
    this.pageRewardPoint = new PageResponse();
    this.openCreateOrEditRewardPointPopup = false;
    this.initRewardPoint = { ...DEFAULT_INITIAL };
    this.openConfirmMessage = null;
  };
}
